import { Box, Grid, Typography, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";

export function MobileDepositSelectedCoin({ selectedCoin }) {
  return (
    <Grid item xs={12}>
      <BoxCoin>
        <img
          src={DefaultUrlWeb + selectedCoin?.imageUrl}
          alt={selectedCoin?.name}
        />

        <Typography component="span" color="text.main">
          {selectedCoin?.name}
        </Typography>
      </BoxCoin>
    </Grid>
  );
}

const BoxCoin = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  alignItems: "center",
  boxSizing: "border-box",
  marginTop: theme.spacing(3),

  img: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    marginBottom: theme.spacing(1),
  },
}));

export default MobileDepositSelectedCoin;
